import { render, staticRenderFns } from "./sum-result-list-component.vue?vue&type=template&id=b3dc959a&scoped=true"
import script from "./sum-result-list-component.ts?vue&type=script&lang=ts&external"
export * from "./sum-result-list-component.ts?vue&type=script&lang=ts&external"
import style0 from "./sum-result-list-component.scss?vue&type=style&index=0&id=b3dc959a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3dc959a",
  null
  
)

export default component.exports